var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"Sound",on:{"click":function($event){return _vm.play()}}},[_c('audio',{ref:"audio",attrs:{"src":_vm.src,"autoplay":false}})])
}
var staticRenderFns = []

export { render, staticRenderFns }